import * as React from 'react';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { SourceConfigType } from '../../../types/administrationTypes';

interface SourcesConfigurationProps {
  sourcesList: SourceConfigType[];
  setSourcesList: React.Dispatch<React.SetStateAction<SourceConfigType[]>>;
}

const SourcesConfiguration: React.FC<SourcesConfigurationProps> = ({ sourcesList, setSourcesList }) => {
  const intl = useIntl();

  return (
    <div className="tff-administration-flex-column">
      <Typography variant="h6" color="primary">
        <strong>{intl.formatMessage({ id: 'administration.sources' })}</strong>
      </Typography>
      {sourcesList.map((source: SourceConfigType, index: number) => {
        const handleSourceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const newState = sourcesList.map(item =>
            item.value === source.value ? { ...item, selected: event.target.checked } : item,
          );
          setSourcesList(newState);
        };
        return (
          <FormControlLabel
            control={
              <Checkbox
                checked={source.selected}
                onChange={handleSourceChange}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                name={source.name}
              />
            }
            label={source.name}
            key={index}
            className="tff-administration-form-label-width"
          />
        );
      })}
    </div>
  );
};

export default SourcesConfiguration;
